import { __ } from "@wordpress/i18n";
import { useBlockProps, InspectorControls } from "@wordpress/block-editor";
import { PanelBody, RangeControl, ColorPalette } from "@wordpress/components";

export default function Edit({ attributes, setAttributes }) {
  const {
    linesHeight,
    lineOneColor,
    lineOneWidth,
    lineTwoColor,
    lineTwoWidth,
    lineThreeColor,
    lineThreeWidth,
    lineFourColor,
    lineFourWidth,
  } = attributes;

  const blockProps = useBlockProps();

  return (
    <>
      <InspectorControls>
        <PanelBody title={__("All Lines Settings", "ofag-separator")}>
          <RangeControl
            label={__("Height (px)", "ofag-separator")}
            value={linesHeight}
            onChange={(height) => setAttributes({ linesHeight: height })}
            min={1}
            max={10}
          />
        </PanelBody>
        {['One', 'Two', 'Three', 'Four'].map((line) => (
          <PanelBody title={__(`Line ${line} Settings`, "ofag-separator")} key={line}>
            <ColorPalette
              value={attributes[`line${line}Color`]}
              onChange={(color) => setAttributes({ [`line${line}Color`]: color })}
            />
            <RangeControl
              label={__("Width (%)", "ofag-separator")}
              value={attributes[`line${line}Width`]}
              onChange={(width) => setAttributes({ [`line${line}Width`]: width })}
              min={1}
              max={100}
            />
          </PanelBody>
        ))}
      </InspectorControls>
	  
      <div {...blockProps} style={{ display: "flex", width: "100%", height: "auto", justifyContent: "space-between", margin: 0, padding: 0, maxWidth: "100vw" }}>
        {['One', 'Three'].map((line) => (
          <div
            key={line}
            className={`ofag-separator__line-${line.toLowerCase()}`}
            style={{
              backgroundColor: attributes[`line${line}Color`],
              height: `${linesHeight}px`,
              width: `${attributes[`line${line}Width`]}%`,
            }}
          ></div>
        ))}
      </div>
      <div style={{ display: "flex", width: "100%", height: "auto", justifyContent: "space-between", margin: 0, padding: 0, maxWidth: "100vw"  }}>
        {['Two', 'Four'].map((line) => (
          <div
            key={line}
            className={`ofag-separator__line-${line.toLowerCase()}`}
            style={{
              backgroundColor: attributes[`line${line}Color`],
              height: `${linesHeight}px`,
              width: `${attributes[`line${line}Width`]}%`,
            }}
          ></div>
        ))}
      </div>
	  
    </>
  );
}
